/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_nb_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binary, octal, decimal, hex`)
};

const es_nb_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binario, octal, decimal, hex`)
};

const de_nb_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binär, Oktal, Dezimal, Hex`)
};

const nl_nb_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binair, octaal, decimaal, hex`)
};

const fr_nb_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binaire, octal, décimal, hexadécimal`)
};

const it_nb_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binario, ottale, decimale, esadecimale`)
};

const pt_br2_nb_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binário, octal, decimal, hexadecimal`)
};

const pt_nb_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binário, octal, decimal, hexadecimal`)
};

const ja_nb_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`二進法、八進法、十進法、十六進法`)
};

const zh_nb_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`二进制、八进制、十进制、十六进制`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const nb_nav_main_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.nb_nav_main_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("nb_nav_main_desc", locale)
	if (locale === "en") return en_nb_nav_main_desc(inputs)
	if (locale === "es") return es_nb_nav_main_desc(inputs)
	if (locale === "de") return de_nb_nav_main_desc(inputs)
	if (locale === "nl") return nl_nb_nav_main_desc(inputs)
	if (locale === "fr") return fr_nb_nav_main_desc(inputs)
	if (locale === "it") return it_nb_nav_main_desc(inputs)
	if (locale === "pt-BR") return pt_br2_nb_nav_main_desc(inputs)
	if (locale === "pt") return pt_nb_nav_main_desc(inputs)
	if (locale === "ja") return ja_nb_nav_main_desc(inputs)
	return zh_nb_nav_main_desc(inputs)
};